<template>

	<div class="body">
		<div class="close-btn" v-on:click="close">
			<i title="close" class="material-icons md-18">close</i>
		</div>

		<div class="title">SAVE PARCEL TO</div>

		<div v-if="token === null" v-on:click="routeLogin" class="lock-block lock-block-sharp">
			<div class="lock-icon-box">
				<i class="material-icons md-36">account_box</i>
			</div>
			<div class="lock-text">
				<h5 class="mb-0 text-white">Sign in to save to collections</h5>
				<h5 class="mb-0 font-weight-light text-light">Store this parcel in an organized list</h5>
			</div>
		</div>

		<ul v-else class="list">
			<li v-if="collections" v-for="(row, index) in collections"
				v-on:click="toggleParcelToCollection(row)" :key="row.id" class="interactive">
				<span v-if="isSavedLoading(row)" class="loader"></span>
				<i v-else-if="isSavedInCollection(row)" class="material-icons md-18">bookmark</i>
				<i v-else class="material-icons md-18">bookmark_border</i> <span>{{row.name}}</span> 
			</li>
			<li v-else class="interactive">
				<i class="material-icons md-18">bookmark_border</i> 
				<span>Favorites</span> 
			</li>
			<li v-if="mode === 'add'" class="position-relative">
				<form class="" v-on:submit.prevent="addCollection">
					<i v-on:click="hideAddForm" class="material-icons md-18 cursor-pointer">close</i> 
					<div class="popup-row-form input-group">
						<input v-model.string="addCollectionName" type="text" class="form-control form-control-sm" placeholder="New collection name"/>
						<div class="input-group-append">
							<button type="submit" class="btn btn-dark btn-sm">Save</button>
						</div>
					</div>
				</form>
			</li>
			<li v-else class="interactive" v-on:click="showAddForm">
				<i class="material-icons md-18">add</i> <span>Add Collection</span> 
			</li>
		</ul>
	</div>
</template>

<script>

export default {
	name:'parcelSave',
	props: {
		addressId:{
			type:Number,
		},
		parcel:{
			type:Object
		}
	},
	computed:{
		collections: function(){
			return this.$store.state.collections.recs;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
	},
	created:function(){
		this.get()
	},
	data:function(){
		return {
			addCollectionName:'',
			copied:false,
			loadError:null,
			loading:true,
			loadingCollections:[],
			mode:null,
		};
	},
	methods:{
		addCollection:async function(){
			try {
				this.loadError = null;
				this.loading = true;
				const collection = await this.$store.dispatch('COLLECTION_ADD',{
					name:this.addCollectionName
				});
				await this.saveParcelToCollection(collection.id)
				this.addCollectionName = '';
				this.mode = null;
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		copyLink:function(){
			this.$copyText(this.link).then((e)=>{
				this.copied = true;
				setTimeout(()=>{
					this.copied = false;
				},800);
			},(e)=>{
				this.$store.dispatch('ERROR_MESSAGE_SET', {message:'Error copying to clipboard'});
				this.copied = false;
			});
		},
		close:function(){
			this.$emit('close');
		},
		get:async function(){
			try {
				this.loadError = null;
				this.loading = true;
				await this.$store.dispatch('COLLECTIONS_GET');
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		isSavedInCollection:function(collection){
			if (!this.parcel.collections) return false;
			for (let i=0,len=this.parcel.collections.length;i<len;i++){
				if (this.parcel.collections[i].id === collection.id) return true;
			}
			return false;
		},
		isSavedLoading:function(collection){
			if (this.loadingCollections.includes(collection.id)) return true;
			return false;
		},
		hideAddForm:function(){
			this.mode = null;
		},
		routeLogin:function(){
			this.$router.push({
				name: 'auth'
			});
		},
		toggleParcelToCollection:async function(collection){
			if (!this.isSavedLoading(collection)) this.loadingCollections.push(collection.id);
			if (this.isSavedInCollection(collection)){
				await this.removeParcelFromCollection(collection.id);
				this.loadingCollections = this.loadingCollections.filter(colId => colId !== collection.id);
			} else {
				await this.saveParcelToCollection(collection.id);
				this.loadingCollections = this.loadingCollections.filter(colId => colId !== collection.id);
			}
		},
		removeParcelFromCollection:async function(collectionId){
			try {
				this.loadError = null;
				this.loading = true;
				await this.$store.dispatch('COLLECTION_PARCEL_REMOVE',{
					addressId: this.addressId,
					parcelId: this.parcel.id,
					collectionId
				});
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		saveParcelToCollection:async function(collectionId){
			try {
				this.loadError = null;
				this.loading = true;
				await this.$store.dispatch('COLLECTION_PARCEL_ADD',{
					addressId: this.addressId,
					parcelId: this.parcel.id,
					collectionId
				});
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		saveParcelToFavorites:async function(){
			try {
				this.loadError = null;
				this.loading = true;
				const collection = await this.$store.dispatch('COLLECTION_ADD',{
					name:''
				});
				await this.saveParcelToCollection(collection.id)
				this.addCollectionName = 'Favorites';
				this.mode = null;
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		showAddForm:function(){
			this.mode = 'add'
		}
	}
};

</script>
<style>

.loader {
    background-color: rgba(0,0,0,0);
    border: 3px solid rgba(39,50,55,0.6);
    opacity: .9;
    border-top: 3px solid rgba(0,0,0,0);
    border-left: 3px solid rgba(0,0,0,0);
    border-radius: 20px;
    width: 18px;
    height: 18px;
    margin: 0 auto;
    -moz-animation: loader-spin .8s infinite linear;
    -webkit-animation: loader-spin .8s infinite linear;
    display:inline-block;
    position:relative;
    top:3px;
    left:0px;
}
@-moz-keyframes loader-spin {
    0% {
        -moz-transform: rotate(0deg);
    }

    100% {
        -moz-transform: rotate(360deg);
    };
}
@-webkit-keyframes loader-spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    };
}

.popup-list{
	list-style-type:none;
	margin:0;padding:0;
}
.popup-list li{
	padding:0 16px;
	border-bottom:1px solid #CFD8DD;
	line-height:40px;
}
.popup-list li.interactive{
	padding:0 16px;
	border-bottom:1px solid #CFD8DD;
	line-height:40px;
	cursor:pointer;
}
.popup-list li.interactive:hover{
	background-color:#EDEFF1;
}
.popup-list li.interactive:hover i{
	color:#CC1717;
}
.popup-list li i{
	position:relative;
	top:-2px;
}
.popup-list .popup-btn{
	cursor:pointer;
}
.popup-list .popup-btn:hover{
	color:#CC1717;
}
.popup-row-form{
	position:absolute !important;
	left:38px;
	right:10px;
	top:5px;
	width:auto !important;
}


</style>


// WEBPACK FOOTER //
// src/components/parcel/parcel-save.vue